const confirmValidationFn = (label, confirm, isRequired) => (value) => {
  if (isRequired && value === '') {
    return `${label} is required.`;
  }
  if (value !== confirm) {
    return `${label} does does not match.`;
  }
  return null;
};

export default confirmValidationFn;
